import React from 'react';
import { FeedResource } from '../types/Feed';
import './DataDisplay.css';

interface DataDisplayProps {
  resources: FeedResource[];
  selectedDate: string;
}

const DataDisplay: React.FC<DataDisplayProps> = ({ resources, selectedDate }) => {
  if (resources.length === 0) {
    return (
      <div className="data-display">
        <p className="no-data">Brak danych dla wybranej daty</p>
      </div>
    );
  }

  return (
    <div className="data-display">
      <h3>Dane z dnia: {formatDate(selectedDate)}</h3>
      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>Tytuł</th>
              <th>Status</th>
              <th>Kategoria</th>
              <th>Data publikacji</th>
              <th>ID zasobu</th>
              <th>Akcje</th>
            </tr>
          </thead>
          <tbody>
            {resources.map(resource => (
              <tr key={resource.id}>
                <td className="title-cell">
                  <div className="title-content">
                    <strong>{resource.title.pl}</strong>
                    {resource.title.en && resource.title.en !== resource.title.pl && (
                      <small className="title-en">{resource.title.en}</small>
                    )}
                  </div>
                </td>
                <td>
                  <span className={`status-badge ${resource.status.toLowerCase()}`}>
                    {resource.status}
                  </span>
                </td>
                <td>{resource.category}</td>
                <td>{formatDate(resource.date)}</td>
                <td className="id-cell">
                  <code>{resource.id}</code>
                </td>
                <td>
                  {resource.url ? (
                    <a
                      href={resource.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="action-link"
                      title="Pobierz dane"
                    >
                      📄 Pobierz
                    </a>
                  ) : (
                    <span className="no-action">-</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const formatDate = (dateString: string): string => {
  try {
    return new Date(dateString).toLocaleDateString('pl-PL', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  } catch {
    return dateString;
  }
};

export default DataDisplay;